import {
    CreateBillingProfileSessionInput,
    CreateBillingProfileSessionMutation,
    CreateBillingProfileSessionMutationVariables,
    CreateBillingProfileSessionResponse
} from "../../API";

import { API } from "aws-amplify";
import { AuthIDTokenSupplierFactory } from "../auth/AuthIDTokenSupplierFactory";
import ClientLogger from "../logging/ClientLogger";
import ClientLoggerFactory from "../logging/ClientLoggerFactory";
import { GraphQLQuery } from "@aws-amplify/api";
import { IDTokenSupplier } from "../auth/IDTokenSupplier";
import { StripeClient } from "./StripeClient";
import { createBillingProfileSession } from "../../graphql/mutations";

export class GraphQLStripeClient implements StripeClient {
    private static readonly CREATE_BILLING_PROFILE_SESSION_ATTEMPT_METRIC_NAME = 'GraphQLStripeClient.createBillingProfileSession.attempt';
    private static readonly CREATE_BILLING_PROFILE_SESSION_FAILURE_METRIC_NAME = 'GraphQLStripeClient.createBillingProfileSession.failure';

    constructor(
        private readonly logger: ClientLogger,
        private readonly idTokenSupplier: IDTokenSupplier
    ) { }

    public async createBillingProfileSession(
        input: CreateBillingProfileSessionInput
    ): Promise<CreateBillingProfileSessionResponse> {
        try {
            this.logger.info(
                'Creating billing profile session',
                {},
                [GraphQLStripeClient.CREATE_BILLING_PROFILE_SESSION_ATTEMPT_METRIC_NAME]
            );
            const authToken: string = await this.idTokenSupplier.get();
            const response = await API.graphql<GraphQLQuery<CreateBillingProfileSessionMutation>>({
                query: createBillingProfileSession,
                variables: { input } satisfies CreateBillingProfileSessionMutationVariables,
                authToken
            });
            const result = response.data?.createBillingProfileSession;
            if (!result) {
                throw new Error('Failed to create billing profile session');
            }
            return result;
        } catch (error) {
            this.logger.error(
                'Failed to create billing profile session',
                error,
                [GraphQLStripeClient.CREATE_BILLING_PROFILE_SESSION_FAILURE_METRIC_NAME]
            );
            throw error;
        }
    }
}

export const graphQLStripeClient = new GraphQLStripeClient(
    ClientLoggerFactory.getClientLogger('GraphQLStripeClient'),
    AuthIDTokenSupplierFactory.getInstance()
);